import Vue from 'vue';
import zenScroll from 'zenscroll';
import Errors from '../classes/Errors';

Vue.component('contact-form-component', {
    props: ['url', 'thankUrl', 'countries', 'languages', 'locale'],
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    computed: {
        filteredCountries() {
            const defaultCountry = _.find(this.countries, { code: 'NL' });
            const disabled = {
                disabled: true,
            };

            return [defaultCountry, disabled, ...this.countries];
        },
    },

    mounted() {
        Vue.nextTick(() => {
            zenScroll.toY(0);
        });
    },

    methods: {

        getCurrentLanguage() {
            if (this.locale === 'nl') {
                return _.find(this.languages, { code: 'nl' });
            }

            return _.find(this.languages, { code: 'en' });
        },

        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post(this.url, new FormData(form))
            .then((response) => {
                this.submitting = false;
                const result = response.data;

                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.scrollToFirstError();
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();

                window.onbeforeunload = null;
                document.location.href = this.thankUrl;
            })
            .catch((error) => {
                this.submitting = false;
                console.log(error);
            });
        },

        /**
         * Handle clicking back to website on the thank-you page.
         *
         * @return {Void}
         */
        onBackToWebsiteClick(event) {
            window.onbeforeunload = null;
            const element = event.currentTarget;

            window.location = element.href;
        },
    },
});
